import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { getBlogArticle } from '../../api/blog-article';

export default function useGetBlogArticle(options) {
  const result = useQuery('get-blog-article', () => getBlogArticle(options), {
    staleTime: 120 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options,
  });

  const formattedResult = useMemo(
    () => ({
      ...result,
      data: result?.data?.data,
    }),
    [result],
  );

  return formattedResult;
}
